import commonUtil from "./common.util";
import {
  MATCH_FILTER_KEYS,
  MATCH_PART_KEYS,
  SIGNAL_FILTERS,
  SORT_ORDER,
  SORT_TYPES,
  STAT_LEVEL_CLASSES,
} from "./constant";

const { getLevelClass } = commonUtil;

function mapTikerList(matches, state) {
  const getSignalPartLevel = (match, part) => {
    let value = part;

    if (!value) {
      if (match.historySignal.length) {
        value = match.historySignal[0].part;
      }
    }

    return value ? (value === MATCH_PART_KEYS.HT ? 1 : 2) : 0;
  };

  return matches.map((match) => {
    if (!match.historySignal) {
      //to do delete this row
      match.historySignal = [];
    }
    const signals = match.historySignal.filter(
      (signal) => signal.event == "forecast",
    );

    const signal = signals[0] ? signals[0] : {};

    const { home, away } = match;

    return {
      ...match,
      isFavorite: state.favorites.includes(match.id),
      mini: state.tickerExpanded.includes(match.id) === false,
      lastSignalTime: signals.reduce(
        (max, signal) => (signal.timestamp > max ? signal.timestamp : max),
        0,
      ),
      historySignal: signals.map((signal) => ({
        ...signal,
        odds: signal.fakeOdds ?? signal.odds,
        $partClass: getLevelClass(
          getSignalPartLevel(null, signal.part),
          STAT_LEVEL_CLASSES.TICKER_SIGNAL_PART,
        ),
      })),
      firstTime:
        match.time > 45
          ? { home: home.score1time, away: away.score1time }
          : false,
      filtered: {
        status: signal.time + 4 > match.time,
        type: signal.type || "Sharp",
        companyId: signal.companyId,
        signal,
        $partClass: getLevelClass(
          getSignalPartLevel(match),
          STAT_LEVEL_CLASSES.TICKER_SIGNAL_PART,
        ),
      },
      $timeLevel: getLevelClass(match.time < 45 ? 1 : 2),
    };
  });
}

function filterList(matches, filters, opts) {
  return filters.reduce((acc, filter) => {
    if (typeof filter === "string" && !opts.noTabFilter) {
      return filterMatches(acc, filter);
    } else if (typeof filter === "object" && !opts.noSignalFilter) {
      return filterMatches(acc, filter.type, filter.value);
    } else {
      return acc;
    }
  }, matches);
}

function filterMatches(matches, filter, filterValue) {
  if (filter === MATCH_FILTER_KEYS.ALL) {
    return matches;
  } else if (filter === MATCH_FILTER_KEYS.FAVORITES) {
    return matches.filter((match) => match.isFavorite);
  } else if (filter === MATCH_FILTER_KEYS.SEARCH) {
    return filterBySearch(matches, filterValue);
  } else if (filter === MATCH_FILTER_KEYS.COMPANY) {
    return filterByCompany(matches, filterValue);
  } else if (filter === MATCH_FILTER_KEYS.SIGNALS) {
    return filterBySignals(matches, filterValue);
  } else if (filter === MATCH_FILTER_KEYS.SIGNAL_TYPES) {
    return filterBySignalType(matches, filterValue);
  } else {
    return matches;
  }
}
function filterBySignals(matches, filterValue) {
  if (filterValue === false) {
    return matches;
  }

  return matches.filter((match) => match.historySignal.length);
}
function filterBySignalType(matches, filterValue) {
  if (!filterValue.size) {
    return matches;
  }

  const signalTypes = [...filterValue].map(
    (filterKey) => SIGNAL_FILTERS[filterKey],
  );

  return matches.filter((match) =>
    match.historySignal.some((row) => signalTypes.includes(row.type)),
  );
}

function filterBySearch(matches, filterValue) {
  if (!filterValue) {
    return matches;
  }

  const searchText = filterValue.toLowerCase();
  return matches.filter(({ home, away, league }) => {
    const names = [home.name, away.name, league];
    return names.some((name = "") => name.toLowerCase().includes(searchText));
  });
}

function sortList(matches, sort, favorite) {
  const { type, order } = sort;

  return [...matches].sort((a, b) => {
    let sortOrder = 0;

    const isFavoriteA = favorite.includes(a.id);
    const isFavoriteB = favorite.includes(b.id);

    if (isFavoriteA && !isFavoriteB) {
      sortOrder = -1;
    } else if (!isFavoriteA && isFavoriteB) {
      sortOrder = 1;
    } else {
      const itemA = type === SORT_TYPES.TIME ? a.time : a.lastSignalTime;
      const itemB = type === SORT_TYPES.TIME ? b.time : b.lastSignalTime;

      if (itemA === itemB) sortOrder = 0;
      sortOrder =
        order === SORT_ORDER.ASC
          ? itemA > itemB
            ? 1
            : -1
          : itemA > itemB
            ? -1
            : 1;
    }

    return sortOrder;
  });
}

function filterByCompany(matches, companyId) {
  if (companyId <= 0) {
    return matches;
  }

  return matches.filter(({ data }) => {
    return data.some((row) => +row.companyId === companyId);
  });
}

function matchCountBySignals(matches, filters) {
  return filters.reduce(
    (acc, key) => ({
      ...acc,
      [key]: matches.filter((match) =>
        match.historySignal.some((row) => row.type === SIGNAL_FILTERS[key]),
      ).length,
    }),
    {},
  );
}

export default {
  mapTikerList,
  filterList,
  filterBySearch,
  sortList,
  filterMatches,
  matchCountBySignals,
};
